import React, {useState} from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import {theme} from '../../../themes/default-theme';
import RespImg from "../../ui/RespImg";

const downSm = '@media (max-width: 939.95px)' // '@media (max-width: 939.95px)'
const upMd = '@media (min-width: 940px)' // '@media (min-width: 940px)'

const Container = styled.div`
    ${theme.breakpoints.up("md")} {
        position: relative;
        > div {
            &:first-child {
                ${props => props.background && `
                    position: fixed;
                    border-right: 53px solid ${props.background};
                    top: 0;
                    bottom: 0;
                    height: 100%;
                    left: 0;
                `}
            }
        }
    }
    ${upMd} {
        top: 87px;
    }

    ${downSm} {
        top: 71px;
        ${props => props.dealer == 1 && `
            top: 63px;
        `}
    }
    ${theme.breakpoints.down("sm")} {
        ${props => props.background && `
            background: ${props.background};
            padding: 12px 20px;
        `}
    }
`

const ModelLogoWrapper = styled.div`
    ${theme.breakpoints.up("md")} {
        height: auto;
        transform: rotate(90deg);
        position: fixed;
        left: -58px;
        margin-top: 50px;
        z-index: 2;
        picture, img {
            width: 169px;
            height: auto;
        }
    }

    ${theme.breakpoints.down("sm")} {
        picture, img {
            width: 127px;
            height: auto;
        }
    }
`
const VerticalLine = styled.div`
    z-index: 2;
`

const ModelLogo = (props) => {

  const {
    bgColour,
    logo
  } = props;
    
  return (
    <>
        { props && logo &&
            <Container background={bgColour} dealer={process.env.DEALER_SITE !== true ? 0 : 1}>
                <VerticalLine></VerticalLine>
                <ModelLogoWrapper>
                    {
                        logo &&
                            <RespImg
                                {...logo}
                            />
                    }

                </ModelLogoWrapper>
            </Container>
        }
    </>
  );
}

ModelLogo.propTypes = {
    bgColour: propTypes.string,
    logo: propTypes.object
};

ModelLogo.defaultProps = {
    bgColour: null,
    logo: {}
}

export default ModelLogo;